import * as React from 'react';

import { clsx } from 'clsx';
import * as style from './style.css';

interface IInfrastructureTypesLayoutProps {
  fixed: boolean;
  children: React.ReactNode;
}

export const InfrastructureTypesLayout: React.FC<IInfrastructureTypesLayoutProps> = ({ fixed, children }) => {
  return <div className={clsx(style['wrapper'], fixed ? style['fixed'] : style['normal'])}>{children}</div>;
};
